<template>
  <div class="bg-contain common-blue-contain">
    <!-- 镜像管理 -->
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('AppManagement') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container app-upgrade view-info common-blue-tabs">
        <el-tabs v-model="appActiveName" type="card" @tab-click="handleClick">
          <el-tab-pane :label="$t('AndroidImage')" name="androidImg"></el-tab-pane>
          <el-tab-pane :label="$t('helmetApp')" name="helmetApp"></el-tab-pane>
          <el-tab-pane :label="$t('remoteApp')" name="remoteControlApp"></el-tab-pane>
          <el-tab-pane :label="$t('manageApps')" name="manageApps"> </el-tab-pane>
          <el-tab-pane :label="$t('deviceZFY')" name="lawEnforcement"> </el-tab-pane>
          <el-tab-pane :label="$t('deviceIPC')" name="ipc" v-if="adminAccount"></el-tab-pane>
          <el-tab-pane :label="$t('deviceIH5')" name="ih5"></el-tab-pane>
        </el-tabs>
        <!-- 头部查询 from -->
        <el-form :inline="true" :model="formInline">
          <el-form-item :label="$t('imageName')">
            <el-input v-model="formInline.imgName" clearable :placeholder="$t('imageName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('versionNo')">
            <el-input v-model="formInline.versionName" clearable :placeholder="$t('versionNo')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('versionDescription')">
            <el-input v-model="formInline.description" clearable :placeholder="$t('versionDescription')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('releaseTime')" class="datetime">
            <el-date-picker
              v-model="formInline.dateFrom"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
              :placeholder="$t('startDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.dateTo"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
              :placeholder="$t('endDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" v-if="adminAccount" @click="addAppLever(appActiveName)">{{
              $t('newlyAded')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <Table
          :tableHeight="595"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :showSelcet="false"
          @operate="operationEvent"
          :operationWidth="200"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增/ 编辑 -->
    <el-dialog
      :title="AppdialogTitle"
      :visible.sync="dialogApp"
      :close-on-click-modal="false"
      :width="appActiveName !== 'manageApps' ? '900px' : '680px'"
      :show-close="false"
      :append-to-body="true"
      class="common-blue-contain app-dialog"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <div :class="appActiveName !== 'manageApps' ? 'left-content' : 'one-content'">
            <el-form-item :label="$t('uploadFiles')" :label-width="formLabelWidth" :required="true">
              <el-upload
                action="string"
                :http-request="importFile"
                :multiple="false"
                :show-file-list="false"
                :before-upload="beforeUpload"
              >
                <el-button type="primary" class="add-btn">{{ $t('uploadFiles') }}</el-button>
                <el-button type="primary" class="add-btn" @click.stop="setImgName()">{{ $t('setImage') }}</el-button>
              </el-upload>
              <el-progress v-if="loading" status="success" :percentage="percent"></el-progress>
            </el-form-item>
            <el-form-item :label="$t('imgName')" :label-width="formLabelWidth">
              <el-input
                v-model="fromData.imgName"
                :disabled="setImgNameFlag"
                :placeholder="$t('nameWithSuffix')"
                maxlength="200"
                clearable
              ></el-input>
              <div class="name-tip">
                {{ $t('forExample') }}：
                <span v-if="appActiveName === 'androidImg'">XXX.zip</span>
                <span v-else-if="appActiveName === 'ih5'">XXX.bin</span>
                <span v-else>XXX.apk</span>
              </div>
            </el-form-item>

            <el-form-item :label="$t('imgUrl')" :label-width="formLabelWidth">
              <el-input
                v-model="fromData.imgUrl"
                :disabled="setImgNameFlag"
                :placeholder="$t('pleaseEnter') + $t('imgUrl')"
                clearable
                maxlength="500"
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="appActiveName === 'androidImg' ? $t('ImageID') : $t('appID')"
              :label-width="formLabelWidth"
              :required="true"
            >
              <el-input
                v-model="fromData.seriesId"
                autocomplete="off"
                :placeholder="$t('pleaseEnter') + $t('identification')"
                clearable
              ></el-input>
              <span class="app-tip" v-if="appActiveName !== 'androidImg'">{{ $t('versionFilled') }}</span>
            </el-form-item>
            <el-form-item :label="$t('versionNo')" :label-width="formLabelWidth" :required="true">
              <el-input
                v-model="fromData.versionName"
                autocomplete="off"
                :placeholder="$t('pleaseEnter') + $t('versionNo')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('VersionNoH')" :label-width="formLabelWidth" :required="true">
              <el-input
                v-model="fromData.versionCode"
                autocomplete="off"
                maxlength="10"
                :placeholder="$t('pleaseEnter') + $t('VersionNoH')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('upgradeType')"
              :label-width="formLabelWidth"
              :required="true"
              v-if="appActiveName === 'androidImg' || appActiveName === 'ih5'"
            >
              <el-radio-group v-model="fromData.upgradeType" @change="selectUpgrade">
                <el-radio :label="1" value="1">{{ $t('fullUpgrade') }}</el-radio>
                <el-radio :label="2" value="2">{{ $t('incrementalUpgrade') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="$t('compatibleVrsion')"
              :label-width="formLabelWidth"
              :required="true"
              v-if="appActiveName === 'androidImg' && fromData.upgradeType === 2"
            >
              <el-input
                v-model="fromData.oldVersionCode"
                autocomplete="off"
                :placeholder="$t('pleaseEnter') + $t('compatibleVrsion')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('minimumVersion')"
              :label-width="formLabelWidth"
              :required="true"
              v-if="appActiveName !== 'androidImg'"
            >
              <el-input
                v-model="fromData.minVersionCode"
                autocomplete="off"
                :placeholder="$t('pleaseEnter') + $t('minimumVersion')"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 发布时间 -->
            <el-form-item :label="$t('releaseTime')" :label-width="formLabelWidth">
              <el-date-picker placeholder="" v-model="fromData.releaseTime" value-format="yyyy-MM-dd" class="dateInput">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('versionDescription')" :label-width="formLabelWidth">
              <el-input
                v-model="fromData.description"
                type="textarea"
                :rows="4"
                :placeholder="$t('pleaseEnter') + $t('versionDescription')"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-right" v-if="appActiveName !== 'manageApps'">
            <el-form-item :label=" $t('OnTenant')" :label-width="formLabelWidth">
              <el-input v-model="searchOu" :rows="1" :placeholder="$t('searchM') + $t('OnTenant')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('OnTenant')" :label-width="formLabelWidth" :required="true">
              <div class="check-box">
                <el-tree
                  ref="checkTree"
                  class="check-tree"
                  :data="rootList"
                  :default-checked-keys="checkList"
                  show-checkbox
                  node-key="id"
                  :check-strictly="true"
                  :props="defaultProps"
                  :check-on-click-node="true"
                  :filter-node-method="filterNode"
                >
                </el-tree>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="berforSubCheck(addOrEdit)" :disabled="isDisabled">{{
          $t('determine')
        }}</el-button>
        <el-button @click="dialogApp = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 升级批次弹窗 -->
    <ChildAppUpgrade
      v-if="dialogLever"
      class="upgrade-main"
      @closeChild="handleClose"
      :childValue="childValue"
      :appActiveName="appActiveName"
    ></ChildAppUpgrade>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import ChildAppUpgrade from '@/views/new-set/sys-setting/ChildAppUpgrade'
import { getSession } from '@/api/common'
import { errorMessage, warning, success } from '@/util/common'
import {
  getUpgradeimg,
  addUpgradeimg,
  editUpgradeimg,
  deleteUpgradeimg,
  orgunitRootList,
  checkupgradeimg,
} from '@/api/upgrade'
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      // 租户管理员
      loginIsAdmin: sessionStorage.getItem('isAdmin') === '1',
      // 平台管理员
      adminAccount: sessionStorage.getItem('account') === 'admin',
      // 镜像/应用 table head
      androidAppRows: [
        {
          attrName: 'versionName',
          label: this.$t('versionNo'),
          sort: 'versionName',
          width: '160',
        },
        {
          attrName: 'imgName',
          label: this.$t('imageName'),
          sort: 'imgName',
        },
        {
          attrName: 'description',
          label: this.$t('versionDescription'),
          sort: 'description',
        },
        {
          attrName: 'releaseTime',
          label: this.$t('releaseTime'),
          width: '140',
          align: 'center',
          sort: 'releaseTime',
        },
        {
          attrName: 'seriesId',
          label: this.$t('ImageID'),
          align: 'right',
          sort: 'seriesId',
        },
        {
          attrName: 'ouNames',
          label: this.$t('OnTenant'),
        },
      ],
      // 管理App table App
      manageAppsRows: [
        {
          attrName: 'versionName',
          label: this.$t('versionNo'),
          sort: 'versionName',
          width: '160',
        },
        {
          attrName: 'imgName',
          label: this.$t('imageName'),
          sort: 'imgName',
        },
        {
          attrName: 'description',
          label: this.$t('versionDescription'),
          sort: 'description',
        },
        {
          attrName: 'releaseTime',
          label: this.$t('releaseTime'),
          width: '140',
          align: 'center',
          sort: 'releaseTime',
        },
      ],
      // 操作按钮
      upgradeBatchOperation: [
        {
          operateName: this.$t('upgradeBatch'),
          type: 'toUpgrade',
          IsHad: '',
          class: 'editClick',
        },
      ],
      // 操作按钮
      adminOperation: [
        {
          operateName: this.$t('upgradeBatch'),
          type: 'toUpgrade',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ],
      controlOperation: [
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ],
      // 搜索表单字段
      formInline: {
        imgName: '',
        seriesId: '',
        versionName: '',
        createBy: '',
        dateFrom: '',
        dateTo: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      dialogApp: false,
      addOrEdit: false,
      // 新增/编辑表单字段
      fromData: {
        file: '',
        imgName: '',
        imgUrl: '',
        seriesId: '',
        versionName: '',
        versionCode: '',
        upgradeType: '1',
        description: '',
        minVersionCode: '',
        ous: [],
        oldVersionCode: '',
      },
      // 机构树被选择的节点数
      checkList: [],
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      formLabelWidth: '150px',
      appActiveName: 'androidImg',
      AppdialogTitle: '',
      dialogLever: false,
      appType: '0',
      // 表单组织机构树 数据
      rootList: [],
      // 当前编辑row
      currentEdit: {},
      // 传数据给‘升级批次弹窗’
      childValue: {},
      // 选择'增量升级'时，是否显示 '兼容版本'
      addLever: false,
      // 进度条是否显示
      loading: false,
      // 进度条初始
      percent: 0,
      // 防止重复点击提交
      isDisabled: false,
      // 搜索过滤机构
      searchOu: '',
      // 手动填入文件名称链接
      setImgNameFlag: true,
    }
  },
  watch: {
    searchOu(val) {
      // 监听搜索机构
      console.log(this.$refs.checkTree, 'this.$refs.checkTree')
      this.$refs.checkTree.filter(val)
    },
  },
  components: {
    Table,
    ChildAppUpgrade,
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.searchList()
    },
    // 机构过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 手动填入文件名称链接
    setImgName() {
      this.setImgNameFlag = false
      this.fromData.imgUrl = null
    },
    // 检查新增外层table 表单，提示相应
    berforSubCheck() {
      if (this.setImgNameFlag === true && this.fromData.imgName === '') {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', { status: 200, data: { state: -1, msg: '请上传文件' } })
        errorMessage('请上传文件')
        return
      } else if (this.setImgNameFlag === false && !this.fromData.imgName && !this.fromData.imgUrl) {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
          status: 200,
          data: { state: -1, msg: '请填入文件名称以及链接' },
        })
        errorMessage(this.$t('setImgNameAndUrl'))
        return
      } else if (this.fromData.seriesId === '') {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
          status: 200,
          data: { state: -1, msg: '请输入镜像标识' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('ImageID'))
        return
      } else if (this.fromData.versionName === '') {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
          status: 200,
          data: { state: -1, msg: '请输入版本号' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('versionNo'))
        return
      } else if (this.fromData.versionCode === '') {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
          status: 200,
          data: { state: -1, msg: '请输入版本编号' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('VersionNoH'))
        return
      } else if (this.appActiveName === 'androidImg' && this.fromData.upgradeType === '') {
        errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
          status: 200,
          data: { state: -1, msg: '请选择升级类型' },
        })
        errorMessage(this.$t('selectUpgradeType'))
        return
      } else {
        let param = {
          description: this.fromData.description,
          imgName: this.fromData.imgName,
          imgUrl: this.fromData.imgUrl,
          imgType: this.appType,
          seriesId: this.fromData.seriesId,
          upgradeType: this.fromData.upgradeType,
          versionCode: this.fromData.versionCode,
          versionName: this.fromData.versionName,
          imgId: this.currentEdit.imgId,
          releaseTime: this.fromData.releaseTime,
        }
        checkupgradeimg(param).then(res => {
          if (res.state === 0) {
            this.submitApp()
          }
        })
      }
    },
    // 提交新增外层table 表单
    submitApp() {
      let formData = new FormData()
      if (this.appActiveName !== 'manageApps') {
        let nodesArr = this.$refs.checkTree.getCheckedNodes()
        // 获取选择的节点
        // 循环添加每个节点的id，tenantId
        for (let i = 0; i < nodesArr.length; i++) {
          formData.append('ous[' + i + '].id', nodesArr[i].id)
          formData.append('ous[' + i + '].tenantId', nodesArr[i].tenantId)
        }
      }
      formData.append('file', this.fromData.file ? this.fromData.file : '')
      formData.append('imgName', this.fromData.imgName)
      formData.append('imgUrl', this.fromData.imgUrl)
      formData.append('imgType', this.appType)
      formData.append('seriesId', this.fromData.seriesId)
      formData.append('createBy', getSession('username'))
      formData.append('versionName', this.fromData.versionName)
      formData.append('versionCode', this.fromData.versionCode)
      formData.append('description', this.fromData.description)
      if (this.fromData.releaseTime) {
        formData.append('releaseTime', this.fromData.releaseTime)
      }

      if (this.fromData.minVersionCode === null) {
        this.fromData.minVersionCode = ''
      }
      if (this.fromData.oldVersionCode === null) {
        this.fromData.oldVersionCode = ''
      }
      if (this.fromData.upgradeType === null) {
        this.fromData.upgradeType = ''
      }
      formData.append('upgradeType', this.fromData.upgradeType)
      formData.append('oldVersionCode', this.fromData.oldVersionCode)
      formData.append('minVersionCode', this.fromData.minVersionCode)

      if (this.appActiveName !== 'manageApps') {
        let nodesData = this.$refs.checkTree.getCheckedNodes()
        if (nodesData.length === 0) {
          errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
            status: 200,
            data: { state: -1, msg: '请选择组织机构' },
          })
          errorMessage(this.$t('peaseSelect') + this.$t('Organization'))
          return
        }
      }
      if (this.appActiveName !== 'androidImg') {
        if (this.fromData.minVersionCode === '') {
          errorCollection('设置》镜像管理', '新增/编辑镜像信息', {
            status: 200,
            data: { state: -1, msg: '请输入最低版本' },
          })
          errorMessage(this.$t('pleaseEnter') + this.$t('minimumVersion'))
          return
        }
      }
      // config 为axios onUploadProgress 上传进度条的方法，在接口添加为传输处理
      var config = {
        onUploadProgress: progressEvent => {
          this.percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
          console.log(this.percent, progressEvent.loaded, progressEvent.total)
        },
      }
      this.isDisabled = true
      if (this.addOrEdit) {
        // true: 为新增
        // true：进度条显示
        this.loading = true
        addUpgradeimg(formData, config).then(res => {
          if (res.state === 0) {
            // false：进度条不显示
            this.loading = false
            // false：防止重复点击提交
            this.isDisabled = false
            this.percent = 0
            this._getUpgradeimg()
            this.dialogApp = false
          } else {
            this.isDisabled = false
          }
        })
      } else {
        // false: 编辑
        // true：进度条显示
        this.loading = true
        formData.append('imgId', this.currentEdit.imgId)
        editUpgradeimg(formData, config).then(res => {
          if (res.state === 0) {
            // false：进度条不显示
            this.loading = false
            this._getUpgradeimg()
            this.dialogApp = false
            // false：防止重复点击提交
            this.isDisabled = false
          } else {
            this.isDisabled = false
          }
        })
      }
      this.addLever = false
    },
    // 关闭子table 刷新table数据
    handleClose() {
      this.dialogLever = false
      this._getorgunitRootList()
      this._getUpgradeimg()
      this.basicConfig()
    },
    //   点击选择升级方式
    selectUpgrade(type) {
      if (type === 1) {
        this.addLever = false
      } else {
        this.addLever = true
      }
    },
    // 上传文件之前的验证
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (this.appActiveName === 'androidImg') {
        if (testmsg != 'tgz' && testmsg != 'zip') {
          warning(this.$t('filesCanOnlBe'))
        }
      } else if (this.appActiveName === 'ih5') {
        if (testmsg != 'bin' && testmsg != 'zip') {
          warning(this.$t('filesCanOnlBeBin'))
        }
      } else if (testmsg !== 'apk') {
        warning(this.$t('uploadedFilesCan'))
      }
    },
    // 点击上传文件
    importFile(value) {
      this.fromData.file = value.file
      this.fromData.imgName = value.file.name
      this.fromData.imgUrl = null
      this.setImgNameFlag = true
    },
    // 点击tab
    handleClick(tab, event) {
      // console.log(tab, event)
      // 根据appActiveName 代表的 tab 的请求数据的type
      if (this.appActiveName === 'androidImg') {
        this.appType = '0'
      } else if (this.appActiveName === 'helmetApp') {
        this.appType = '1'
      } else if (this.appActiveName === 'remoteControlApp') {
        this.appType = '2'
      } else if (this.appActiveName === 'manageApps') {
        this.appType = '3'
      } else if (this.appActiveName === 'lawEnforcement') {
        this.appType = '4'
      } else if (this.appActiveName === 'ipc') {
        this.appType = '5'
      } else if (this.appActiveName === 'cabinetApp') {
        this.appType = '6'
      } else if (this.appActiveName === 'ih5') {
        this.appType = '7'
      }
      this._getUpgradeimg()
      this.basicConfig()
    },
    // 点击新增按钮事件
    addAppLever(type) {
      // 清空上一次内容
      this.fromData = {
        file: '',
        imgName: '',
        imgUrl: '',
        seriesId: '',
        versionName: '',
        versionCode: '',
        upgradeType: 1,
        description: '',
        minVersionCode: '',
        ous: [],
        oldVersionCode: '',
      }
      this.setImgNameFlag = true
      this.loading = false
      this.checkList = []
      // 根据type不同是 弹窗 标题不一样
      if (type === 'androidImg') {
        this.AppdialogTitle = this.$t('newimageInformation')
      } else {
        this.AppdialogTitle = this.$t('apkInformation')
      }
      this._getorgunitRootList()
      this.addOrEdit = true
      this.dialogApp = true
    },
    // 所有租户根组织架构数据
    _getorgunitRootList() {
      if (!this.adminAccount) {
        return
      }
      orgunitRootList().then(res => {
        if (res.state === 0) {
          this.rootList = res.data
          // console.log(this.rootList, 'rootList')
          this.$nextTick(() => {
            if (this.$refs.checkTree) {
              this.$refs.checkTree.filter(this.searchOu)
            }
          })
        }
      })
    },
    // 外层table 操作事件
    operationEvent(row, value, index) {
      // 当点击编辑时，子组件返回，去执行编辑事件
      if (row.type === 'edit') {
        this.editChannelInfo(row.value)
      } else if (row.type === 'toUpgrade') {
        // 当点击升级批次时，子组件返回，去执行事件
        this.upgradeLever(row.value)
      } else {
        // 当点击删除时，子组件返回，去执行
        this.delectInfo(row.value)
      }
    },
    // 点击升级批次后，升级批次组件显示
    upgradeLever(value) {
      this.childValue = value
      this.dialogLever = true
    },
    // 编辑
    editChannelInfo(row) {
      this.currentEdit = row
      this._getorgunitRootList()
      console.log(row, 'edit')
      this.fromData = Object.assign({}, row)
      this.checkList = []
      this.$nextTick(() => {
        this.checkList = row.ouIds
      })
      if (this.appActiveName === 'androidImg') {
        this.AppdialogTitle = this.$t('editImageInformation')
      } else if (this.appActiveName === 'remoteControlApp') {
        this.fromData.upgradeType = ''
      } else {
        this.AppdialogTitle = this.$t('editApkInformation')
      }
      this.addOrEdit = false
      this.dialogApp = true
      this.loading = false
    },
    // 删除外层table row
    delectInfo(row) {
      // console.log(row, 'delect')
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { imgId: row.imgId }
        deleteUpgradeimg(param).then(res => {
          if (res.state === 0) {
            this._getUpgradeimg()
            console.log(res)
          }
        })
      })
    },
    // 点击页脚，选择一页多少条数据
    handleSizeChange(val) {
      this.pageSize = val
      this._getUpgradeimg()
    },
    // 输入去第几页数据
    handleCurrentChange(val) {
      this.currentPage = val
      this._getUpgradeimg()
    },
    // table 基本配置
    basicConfig() {
      // 根据不同tab table的操作栏 加载不同
      this.dateOperation = []
      // 根据不同tab table的header 加载不同
      this.columns = []
      if (
        this.appActiveName === 'androidImg' ||
        this.appActiveName === 'helmetApp' ||
        this.appActiveName === 'remoteControlApp' ||
        this.appActiveName === 'lawEnforcement' ||
        this.appActiveName === 'ipc' ||
        this.appActiveName === 'ih5'
      ) {
        if (this.appActiveName === 'remoteControlApp') {
          if (this.adminAccount) {
            this.dateOperation = this.controlOperation
          }
          this.columns = this.androidAppRows
        } else if (this.adminAccount) {
          this.dateOperation = this.adminOperation
          this.columns = this.androidAppRows
        } else {
          this.dateOperation = this.upgradeBatchOperation
          this.columns = this.manageAppsRows
        }
      } else if (this.appActiveName === 'manageApps') {
        this.columns = this.manageAppsRows
        if (this.adminAccount) {
          this.dateOperation = this.controlOperation
        }
      }
    },
    // 输入查询条件，进行查询
    searchList() {
      this.currentPage = 1
      this._getUpgradeimg()
    },
    // 获取 table 数据
    _getUpgradeimg() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        imgType: this.appType,
        imgName: this.formInline.imgName,
        description: this.formInline.description,
        versionName: this.formInline.versionName,
        dateFrom: this.formInline.dateFrom,
        dateTo: this.formInline.dateTo,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getUpgradeimg(param).then(res => {
        if (res.state === 0) {
          for (let item of res.value.list) {
            item.ouNames = ''
            if (item.ouIds !== null) {
              item.ouIds.map(ids => {
                this.rootList.map(rootItem => {
                  if (ids === rootItem.id) {
                    let name = rootItem.name
                    if (item.ouNames !== '') {
                      item.ouNames = item.ouNames + ',' + name
                    } else {
                      item.ouNames = name
                    }
                    return item
                  }
                })
              })
            }
            if (item.upgradeType === 2) {
              item.upgradeName = this.$t('incrementalUpgrade')
            } else if (item.upgradeType === 1) {
              item.upgradeName = this.$t('fullUpgrade')
            }
          }
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
  },
  mounted() {
    this._getorgunitRootList()
  },
  created() {
    // this._getorgunitRootList()
    this._getUpgradeimg()
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'

.el-form-item__content
  position relative
.check-box
  width 100%
  .check-tree
    max-height 480px
    min-height 300px
    overflow auto
.file-name
  margin-left 5px
  width 280px;/* no */
  line-height 18px
  display inline-block
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  text-align left
.upgrade-main
  width 100%
.el-tabs
  margin 0 0 16px
.el-tree
  height 100%
  overflow auto
  padding 10px 20px
  border var(--search-input-border)
  color var(--new-el-select-dropdown-item);
// .el-input
//   width 100%!important
.name-tip
  margin-left 10px
  line-height 18px
  font-size 12px
  font-style italic
  color #409eff
  font-style oblique
#nprogress .bar
  background: red !important; //自定义颜色
  height: 10px
.app-tip
  display block
  font-size 12px
  line-height 18px;/*no*/
  font-style italic
  color #409eff
  // color #00deff
.app-dialog
  >>>.el-dialog__body
    overflow-y: auto;
  .settingDialog
    display flex
    overflow hidden
    flex-direction row
    color var(--search-label-color)
    .left-content
      width 49%
    .form-right
      width 51%
    .one-content
      width 100%
.bg-contain .common-table-cnt .table-box /deep/ .el-table {
  height: 580px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
